import { TyreFilter } from "@tm/models"

export function splitSeasonFromTyreModel(tyreModels: TyreFilter[]) {
    return tyreModels.map((model) => {
        const [seasonPrefix, modelName] = model.value.split("#")
        return { seasonPrefix, modelName }
    })
}
